(function () {

  var ECO_BUYBACK_API =
    "https://script.google.com/macros/s/AKfycbxgOgUY6RHdNi--y0Holrepyu4-Kb90ao3TJD1edZM92LAopcmYU7Ca9RWKs26zlWo2/exec";

  window.BUYBACK_PRICE_DATA = {
    items: []
  };

  fetch(ECO_BUYBACK_API + "?action=buyback-data&t=" + Date.now(), {
    method: "GET",
    cache: "no-store"
  })
    .then(function (response) {

      if (!response.ok) {
        throw new Error("Árlista lekérési hiba.");
      }

      return response.json();
    })

    .then(function (data) {

      if (
        !data ||
        data.success !== true ||
        !Array.isArray(data.items)
      ) {
        throw new Error("Érvénytelen árlista.");
      }

      window.BUYBACK_PRICE_DATA = {
        items: data.items,
        updatedAt: data.updatedAt || null
      };

      window.IPHONE_BUYBACK_PRICELIST = data.items;

      console.log(
        "EcoMobil árlista betöltve:",
        data.items.length,
        "sor"
      );

    })

    .catch(function (error) {

      console.error(
        "EcoMobil árlista betöltési hiba:",
        error
      );

    });

})();